export const FETCH_ALL = 'FETCH_ALL'
export const FETCH_POST = 'FETCH_POST'
export const FETCH_BY_SEARCH = 'FETCH_BY_SEARCH'
export const FETCH_LIKED = 'FETCH_LIKED'
export const FETCH_RECOMMENDED = 'FETCHED_RECOMMENDED'
export const FETCH_CREATED = 'FETCH_CREATED'
export const FETCH_PRIVATE = 'FETCH_PRIVATE'
export const USER_DETAILS = 'USER_DETAILS'
export const CREATE = 'CREATE'
export const UPDATE = 'UPDATE'
export const DELETE = 'DELETE'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const AUTH = 'AUTH'
export const LOGOUT = 'LOGOUT'
export const LIKE = 'LIKE'
export const COMMENT = 'COMMENT'
export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'
export const FETCHING_LIKED_POSTS = 'FETCHING_LIKED_POSTS'
export const FETCHED_LIKED_POSTS = 'FETCHED_LIKED_POSTS'
export const FETCHING_CREATED_POSTS = 'FETCHING_CREATED_POSTS'
export const FETCHING_RECOMMENDED_POSTS = 'FETCHING_RECOMMENDED_POSTS'

export const FETCHED_CREATED_POSTS = 'FETCHED_CREATED_POSTS'
export const FETCHING_PRIVATE_POSTS = 'FETCHING_PRIVATE_POSTS'
export const FETCHED_PRIVATE_POSTS = 'FETCHED_PRIVATE_POSTS'
export const FETCHED_RECOMMENDED_POSTS =   'FETCHED_RECOMMENDED_POSTS'


